{
  const addAllSelector = '.wishlist-page-add-all-btn';

  const updateCartBubble = (sectionHtml) => {
    const bubble = document.getElementById('CartBubble');
    if (!bubble || typeof sectionHtml !== 'string') return;

    const count = sectionHtml.match(/\d+/)?.[0] ?? '';
    bubble.textContent = count;
    bubble.classList.toggle('hidden', count === '');
  };

  const addAllToCartWithoutRedirect = async (page, button) => {
    const items = page.getAddableCartItems();
    if (items.length === 0) return;

    const label = button.querySelector('.wishlist-page-add-all-text');
    const spinner = button.querySelector('.wishlist-page-add-all-spinner');

    label?.classList.add('hidden');
    spinner?.classList.remove('hidden');
    button.disabled = true;
    page.clearCartError();

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-bubble'] })
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || window.cartStrings.error);
      }

      updateCartBubble(data.sections?.['cart-bubble']);
    } catch (error) {
      page.showCartError(error);
    } finally {
      spinner?.classList.add('hidden');
      label?.classList.remove('hidden');
      page._syncAddAllButton(button, label, 'wishlist-page-add-all-btn--oos');
    }
  };

  const productRequests = new Map();

  const fetchProduct = (handle) => {
    if (!productRequests.has(handle)) {
      const request = fetch(`${window.Shopify?.routes?.root ?? '/'}products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
      productRequests.set(handle, request);
    }

    return productRequests.get(handle);
  };

  const formatMoney = (cents) => {
    const value = cents / 100;
    const withSeparators = (decimals, thousands, decimal) => {
      const [integer, fraction] = value.toFixed(decimals).split('.');
      const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${grouped}${decimal}${fraction}` : grouped;
    };
    const amounts = {
      amount: () => withSeparators(2, ',', '.'),
      amount_no_decimals: () => withSeparators(0, ',', '.'),
      amount_with_comma_separator: () => withSeparators(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => withSeparators(0, '.', ','),
      amount_with_apostrophe_separator: () => withSeparators(2, "'", '.')
    };

    return (window.shopMoneyFormat || '{{amount}}').replace(
      /\{\{\s*(\w+)\s*\}\}/,
      (match, key) => (amounts[key] ?? amounts.amount)()
    );
  };

  const buildPriceHtml = (variant) => {
    const strings = window.priceStrings ?? {};
    const price = formatMoney(variant.price);

    if (!(variant.compare_at_price > variant.price)) {
      return `<div class="price flex flex-wrap flex-row-reverse justify-end whitespace-nowrap gap-x-2">
        <span class="visually-hidden">${strings.regularPrice ?? ''}</span>
        <span class="regular-price">${price}</span>
      </div>`;
    }

    return `<div class="price flex flex-wrap flex-row-reverse justify-end whitespace-nowrap gap-x-2">
      <span class="visually-hidden order-2">${strings.salePrice ?? ''}</span>
      <span class="sale-price order-2">${price}</span>
      <span class="visually-hidden">${strings.regularPrice ?? ''}</span>
      <s class="regular-price opacity-60">${formatMoney(variant.compare_at_price)}</s>
    </div>`;
  };

  const renderRowPrice = async (row) => {
    const { handle, variantId } = row.dataset;
    if (!handle || !variantId) return;

    const alreadyRendered =
      row.dataset.themePriceVariant === variantId &&
      row.querySelector('.wishlist-theme-price') &&
      row.querySelector('.wishlist-theme-price-cell');
    const inProgress = row.dataset.themePriceLoading === variantId;
    if (alreadyRendered || inProgress) return;

    row.dataset.themePriceLoading = variantId;

    const product = await fetchProduct(handle);
    delete row.dataset.themePriceLoading;

    const variant = product?.variants.find((item) => String(item.id) === variantId);
    if (!variant || row.dataset.variantId !== variantId) return;

    row.dataset.themePriceVariant = variantId;

    const priceHtml = buildPriceHtml(variant);
    const title = row.querySelector('.wishlist-page-row-title');
    const priceCell = row.querySelector('.wishlist-page-cell--price');

    row.querySelector('.wishlist-theme-price')?.remove();
    title?.insertAdjacentHTML('afterend', `<div class="wishlist-theme-price">${priceHtml}</div>`);

    if (priceCell) {
      priceCell.innerHTML = `<div class="wishlist-theme-price-cell">${priceHtml}</div>`;
    }
  };

  const themeHeartSelector = '[data-wishlist-handle]';

  const syncThemeHearts = (items = window.wishlistApp?.wishlist ?? []) => {
    const handles = new Set(items.map((item) => (typeof item === 'string' ? item : item.handle)));

    document.querySelectorAll(themeHeartSelector).forEach((button) => {
      const isActive = handles.has(button.dataset.wishlistHandle);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  };

  const toggleThemeHeart = (button) => {
    const app = window.wishlistApp;
    if (!app) return;

    const { wishlistHandle, wishlistTitle, wishlistImage, wishlistPrice, wishlistVariantId } = button.dataset;
    const proxy = document.createElement('button');
    proxy.dataset.productId = wishlistHandle;
    proxy.dataset.productTitle = wishlistTitle ?? '';
    proxy.dataset.productImage = wishlistImage ? new URL(wishlistImage, window.location.origin).href : '';
    proxy.dataset.productPrice = wishlistPrice ?? '';
    if (wishlistVariantId) proxy.dataset.variantId = wishlistVariantId;

    const request = app.toggleWishlist(wishlistHandle, proxy);
    syncThemeHearts();
    request.then(() => syncThemeHearts());
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(themeHeartSelector);
    if (!button) return;

    event.preventDefault();
    toggleThemeHeart(button);
  });

  window.addEventListener('wishlist:updated', (event) => {
    syncThemeHearts(event.detail?.wishlist);
  });

  document.addEventListener('wishlist:render', () => syncThemeHearts());
  document.addEventListener('shopify:section:load', () => syncThemeHearts());

  document.addEventListener('DOMContentLoaded', () => {
    const app = window.wishlistApp;
    if (!app) return;

    const start = app.start.bind(app);
    app.start = async () => {
      await start();
      syncThemeHearts();
    };

    syncThemeHearts();
  });

  const wishlistRoot = document.getElementById('magic-wishlist-page-root');

  if (wishlistRoot) {
    const renderAllPrices = () => {
      wishlistRoot.querySelectorAll('.wishlist-page-row[data-handle]').forEach(renderRowPrice);
    };

    new MutationObserver(renderAllPrices).observe(wishlistRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-variant-id']
    });

    renderAllPrices();
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.(addAllSelector);
      const page = window.wishlistPage;

      if (!button || !page || page.activeTab === 'sfl') return;

      event.stopPropagation();
      event.preventDefault();
      addAllToCartWithoutRedirect(page, button);
    },
    true
  );
}